// filepath: src/Details.js
function Details() {
  return (
    <div className="container2">
      <div className="containerchild">
        <p>
          <span style={{ color: 'var(--cybertext3)', fontSize: 14 }}>
            {/* Details here */}
            // Гео: Russia, Moscow <br />
            // Рост:      171 cm <br />
            // Вес:      64 kg <br />
            // <br />
            // Ранг: SS <br />
            // Компетенции: <br />
            ------ Крипторынок <br />
            ------ English level - C1 <br />
            ------ Дизайн <br />
            ------ Маркетинг <br />
            ------ Контент <br />
            ------ Продажи <br />
          </span>
        </p>
      </div>
    </div>
  );
}

export default Details;